import React, {Component} from 'react'
import CustomTable from '../../../../../elements/Table/CustomTable'
import moment from 'moment'
import {dateFormat} from '../../../../../modules/Utils'

class DeliveryList extends Component {
  columns = [
    {
      Header: 'Delivery Date',
      accessor: 'date',
      Cell: ({value}) => value && dateFormat(moment(value)),
    },
    {
      Header: 'Delivery Notes',
      accessor: 'notes',
    },
    {
      Header: 'Stock Name',
      accessor: 'orderLine.ref.product.name',
    },
    {
      Header: 'Service',
      accessor: 'orderLine.ref.name',
    },
    {
      Header: 'Pick up Location',
      accessor: 'orderLine.pickup.location.address',
    },
    {
      Header: 'Pick up',
      accessor: 'orderLine.pickup.date',
      Cell: ({value}) => value && dateFormat(moment(value)),
    },
    {
      Header: 'Pick up Notes',
      accessor: 'orderLine.pickup.notes',
    },
    {
      Header: 'Drop off Location',
      accessor: 'orderLine.dropoff.location.address',
    },

    {
      Header: 'Drop Off Notes',
      accessor: 'orderLine.dropoff.notes',
    },
  ]

  render() {
    const {deliveries, fetchDeliveries, fetchingDeliveries} = this.props
    return (
      <CustomTable
        columns={this.columns}
        data={deliveries}
        fetch={fetchDeliveries}
        fetching={fetchingDeliveries}
      />
    )
  }
}

DeliveryList.propTypes = {}
DeliveryList.defaultProps = {}

export default DeliveryList
